import React, { useState, useEffect } from "react";
import s from "./styles.module.scss";
import { Link } from "react-router-dom";
import Select from "react-select";

interface selectObjectProps {
  value: string;
  label: string;
  populateValue?: string;
}

interface inputFieldSelectProps {
  readonly options: Array<selectObjectProps>;
  fieldName: string;
  saveValue: (obj: { field: string; value: string }) => void;
  populateValue?: selectObjectProps;
  enhanced?: boolean;
  required?: boolean;
  showErrors?: boolean;
}

export const InputFieldSelect = (props: inputFieldSelectProps) => {
  const {
    options,
    saveValue,
    fieldName,
    populateValue,
    enhanced = false,
    required = false,
    showErrors = false,
  } = props;
  const [valueToSave, setValueToSave] = useState<selectObjectProps | undefined>(
    populateValue
  );
  const [error, setError] = useState("");

  useEffect(() => {
    if (showErrors && required && !valueToSave?.value) {
      setError("This field is required");
    } else {
      setError("");
    }
  }, [showErrors, required, valueToSave]);

  const onChange = (option: selectObjectProps | null) => {
    if (option) {
      setValueToSave(option);
      setError("");
      saveValue({ field: fieldName, value: option.value });
    }
  };

  const customStyles = enhanced
    ? {
        control: (provided: any, state: any) => ({
          ...provided,
          borderRadius: "8px",
          border: state.isFocused
            ? "2px solid #87ceeb"
            : error
            ? "2px solid #87ceeb"
            : "2px solid #87ceeb",
          boxShadow: state.isFocused
            ? "0 4px 15px rgba(135, 206, 235, 0.25)"
            : error
            ? "0 4px 10px rgba(135, 206, 235, 0.1)"
            : "0 4px 10px rgba(0, 0, 0, 0.05)",
          padding: 0,
          fontSize: "18px",
          minHeight: "56px",
          height: "56px",
          transition: "all 0.3s ease",
          backgroundColor: error ? "#f0f8ff" : "#fff",
          "&:hover": {
            borderColor: state.isFocused
              ? "#87ceeb"
              : error
              ? "#87ceeb"
              : "#87ceeb",
          },
          alignItems: "center",
        }),
        valueContainer: (provided: any) => ({
          ...provided,
          padding: "0 12px",
          height: "56px",
        }),
        input: (provided: any) => ({
          ...provided,
          margin: 0,
          padding: 0,
        }),
        indicatorsContainer: (provided: any) => ({
          ...provided,
          height: "56px",
        }),
        dropdownIndicator: (provided: any) => ({
          ...provided,
          padding: "0 8px",
        }),
        option: (provided: any, state: any) => ({
          ...provided,
          backgroundColor: state.isSelected
            ? "#87ceeb"
            : state.isFocused
            ? "#e6f3ff"
            : null,
          color: state.isSelected ? "white" : state.isFocused ? "#333" : null,
          "&:hover": {
            backgroundColor: state.isSelected ? "#87ceeb" : "#e6f3ff",
            color: state.isSelected ? "white" : "#333",
          },
        }),
        menu: (provided: any) => ({
          ...provided,
          borderRadius: "8px",
          boxShadow: "0 6px 16px rgba(0, 0, 0, 0.1)",
          zIndex: 20000,
        }),
        menuPortal: (base: any) => ({
          ...base,
          zIndex: 20000,
        }),
      }
    : undefined;

  return (
    <>
      <Select
        className={`${s.inputSelectStyle} ${enhanced ? s.enhanced : ""}`}
        options={options}
        onChange={onChange}
        value={valueToSave}
        styles={customStyles}
        menuPortalTarget={document.body}
        menuPosition="fixed"
        isClearable={!required}
      />
      <span
        className={s.notice}
        style={{
          opacity: error ? 1 : 0,
          pointerEvents: error ? "auto" : "none",
        }}
      >
        {error || ""}
      </span>
    </>
  );
};
